export default "__VITE_ASSET__C_d42rlQ__"